/** @jsxImportSource @emotion/react */
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import FavoriteIcon from '@mui/icons-material/Favorite';
import HelpIcon from '@mui/icons-material/Help';
import HomeIcon from '@mui/icons-material/Home';
import HotelIcon from '@mui/icons-material/Hotel';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PeopleIcon from '@mui/icons-material/People';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import ScheduleIcon from '@mui/icons-material/Schedule';
import TableRestaurantIcon from '@mui/icons-material/TableRestaurant';
import React from "react";

export interface FeatureData {
    id: string;
    sectionId: string;
    icon: React.ReactNode;
    title: string;
    buttonName: string;
    description: string;
  }
  
  export const getFeatureData: (t: any) => FeatureData[] = (t: any) => [
    {
      id: "title",
      sectionId: "title",
      icon: <HomeIcon />,
      title: t("features.sections.title.name"),
      buttonName: t("features.sections.title.buttonName"),
      description: t("features.sections.title.description")
    } as FeatureData,
    {
      id: "location",
      sectionId: "location",
      icon: <LocationOnIcon />,
      title: t("features.sections.location.name"),
      buttonName: t("features.sections.location.buttonName"),
      description: t("features.sections.location.description")
    } as FeatureData,
    {
      id: "faq",
      sectionId: "faq",
      icon: <HelpIcon />,
      title: t("features.sections.faq.name"),
      buttonName: t("features.sections.faq.buttonName"),
      description: t("features.sections.faq.description")
    } as FeatureData,
    {
      id: "weddingWitnesses",
      sectionId: "weddingWitnesses",
      icon: <PeopleIcon />,
      title: t("features.sections.weddingWitnesses.name"),
      buttonName: t("features.sections.weddingWitnesses.buttonName"),
      description: t("features.sections.weddingWitnesses.description")
    } as FeatureData,
    {
      id: "memories",
      sectionId: "memories",
      icon: <FavoriteIcon />,
      title: t("features.sections.memories.name"),
      buttonName: t("features.sections.memories.buttonName"),
      description: t("features.sections.memories.description")
    } as FeatureData,
    {
      id: "rsvp",
      sectionId: "rsvp",
      icon: <EventAvailableIcon />,
      title: t("features.sections.rsvp.name"),
      buttonName: t("features.sections.rsvp.buttonName"),
      description: t("features.sections.rsvp.description")
    } as FeatureData,
    {
      id: "tables",
      sectionId: "tables",
      icon: <TableRestaurantIcon />,
      title: t("features.sections.tables.name"),
      buttonName: t("features.sections.tables.buttonName"),
      description: t("features.sections.tables.description")
    } as FeatureData,
    {
      id: "schedule",
      sectionId: "schedule",
      icon: <ScheduleIcon />,
      title: t("features.sections.schedule.name"),
      buttonName: t("features.sections.schedule.buttonName"),
      description: t("features.sections.schedule.description")
    } as FeatureData,
    {
      id: "accommodation",
      sectionId: "accomodation",
      icon: <HotelIcon />,
      title: t("features.sections.accommodation.name"),
      buttonName: t("features.sections.accommodation.buttonName"),
      description: t("features.sections.accommodation.description")
    } as FeatureData,
    {
      id: "menu",
      sectionId: "menu",
      icon: <RestaurantMenuIcon />,
      title: t("features.sections.menu.name"),
      buttonName: t("features.sections.menu.buttonName"),
      description: t("features.sections.menu.description")
    } as FeatureData
  ];